export default [
  {
    path: "/admin/competing_difficulty_level_rules",
    name: "CompetingDifficultyLevelRules",
    meta: {
      requireAuthorize: true,
      anchor: "#jumpBreadcrumb"
    },
    component: () =>
      import(
        "@/components/master_data/competing/CompetingDifficultyLevelRules.vue"
      )
  },
  {
    path: "/admin/competing_difficulty_level_definitions",
    name: "CompetingDifficultyLevelDefinitions",
    meta: {
      requireAuthorize: true,
      anchor: "#jumpBreadcrumb"
    },
    component: () =>
      import(
        "@/components/master_data/competing/CompetingDifficultyLevelDefinitions.vue"
      )
  },
  {
    path: "/admin/competing_difficulty_level_groups",
    name: "CompetingDifficultyLevelGroups",
    meta: {
      requireAuthorize: true,
      anchor: "#jumpBreadcrumb"
    },
    component: () =>
      import(
        "@/components/master_data/competing/CompetingDifficultyLevelGroups.vue"
      )
  },
  {
    path: "/admin/regions",
    name: "Regions",
    component: () => import("@/components/master_data/CountryRegions.vue")
  },
  {
    path: "/admin/insurance_categories",
    name: "InsuranceCategories",
    component: () => import("@/components/master_data/InsuranceCategories.vue")
  },
  {
    path: "/admin/horse_document_issuing_bodies",
    name: "horseDocumentIssuingBodies",
    component: () =>
      import("@/components/master_data/HorseDocumentIssuingBodies.vue")
  },
  {
    path: "/admin/horse_colors",
    name: "HorseColors",
    component: () => import("@/components/master_data/HorseColors.vue"),
    meta: { anchor: "#jumpMobile" }
  },
  {
    path: "/admin/studbooks",
    name: "Studbooks",
    component: () => import("@/components/master_data/Studbooks.vue"),
    meta: { anchor: "#jumpMobile" }
  },
  {
    path: "/admin/certificate_groups",
    name: "CertificateGroups",
    component: () =>
      import("@/components/master_data/certificates/CertificateGroups.vue"),
    meta: { anchor: "#jumpMobile" }
  },
  {
    path: "/admin/cerfiticate_definitions",
    name: "CertificateDefinitions",
    component: () =>
      import(
        "@/components/master_data/certificates/CertificateDefinitions.vue"
      ),
    meta: { anchor: "#jumpMobile" }
  },
  {
    path: "/admin/organisational_functions",
    name: "OrganisationalFunctions",
    component: () =>
      import("@/components/master_data/OrganisationalFunctions.vue"),
    meta: { anchor: "#jumpMobile" }
  },
  {
    path: "/admin/organisational_titles",
    name: "OrganisationalTitles",
    component: () =>
      import("@/components/master_data/OrganisationalTitles.vue"),
    meta: { anchor: "#jumpMobile" }
  },
  {
    path: "/admin/exam_groups",
    name: "ExamGroups",
    component: () => import("@/components/master_data/exams/ExamGroups.vue"),
    meta: { anchor: "#jumpMobile" }
  },
  {
    path: "/admin/exam_definitions",
    name: "ExamDefinitions",
    component: () =>
      import("@/components/master_data/exams/ExamDefinitions.vue"),
    meta: { anchor: "#jumpMobile" }
  },
  {
    path: "/admin/competition_entry_rule_templates",
    name: "CompetitionEntryRuleTemplates",
    component: () =>
      import("@/components/master_data/CompetitionEntryRuleTemplates.vue"),
    meta: { anchor: "#jumpMobile" }
  },
  {
    path: "/admin/legal_forms",
    name: "LegalForms",
    component: () => import("@/components/master_data/LegalForms.vue"),
    meta: { anchor: "#jumpMobile" }
  },
  {
    path: "/admin/query_definitions",
    name: "QueryDefinitions",
    component: () => import("@/components/master_data/QueryDefinitions.vue"),
    meta: { anchor: "#jumpMobile" }
  },
  {
    path: "/admin/role_comparisions",
    name: "RoleComparisionsTable",
    component: () =>
      import("@/components/master_data/RolesList/permissions_table"),
    meta: { anchor: "#jumpMobile" }
  },
  {
    path: "/reports",
    name: "Reports",
    meta: { breadcrumb: "Reports", requireAuthorize: true },
    component: () => import("@/components/master_data/Reports")
  },
  {
    path: "/admin/event_categories",
    name: "EventCategories",
    meta: { breadcrumb: "Event categories", requireAuthorize: true },
    component: () =>
      import("@/components/master_data/EventCategories/EventCategories.vue")
  },
  {
    path: "/admin/licence_checks",
    name: "LicenceChecks",
    meta: { breadcrumb: "LicenceChecks", requireAuthorize: true },
    component: () => import("@/components/master_data/LicenceChecks")
  },
  {
    path: "/admin/banners_management",
    name: "BannersManagement",
    meta: { breadcrumb: "BannersManagement", requireAuthorize: true },
    component: () => import("@/components/master_data/BannersManagement")
  },
  {
    path: "/admin/translations",
    name: "AdminTranslations",
    meta: { breadcrumb: "Translations", requireAuthorize: true },
    component: () => import("@/components/master_data/Translations")
  },
  {
    path: "/admin/products_management",
    name: "ProductsManagement",
    meta: { breadcrumb: "ProductsManagement", requireAuthorize: true },
    component: () => import("@/components/master_data/ProductsManagement")
  },
  {
    path: "/admin/actions",
    name: "ActionsList",
    component: () => import("@/components/master_data/ActionsList"),
    meta: { requireAuthorize: true }
  },
  {
    path: "/admin/lists",
    name: "MasterDataManagementPage",
    component: () =>
      import("@/components/master_data/MasterDataManagementPage"),
    meta: { requireAuthorize: true }
  },
  {
    path: "/admin/cancelreasons",
    name: "CancelReasons",
    component: () => import("@/components/master_data/CancelReasons"),
    meta: { requireAuthorize: true }
  },
  {
    path: "/admin/lists/disciplines",
    name: "DisciplinesList",
    component: () => import("@/components/master_data/DisciplinesList"),
    meta: { requireAuthorize: true }
  },
  {
    path: "/admin/lists/profQualificationGroups",
    name: "ProfQualificationGroupsList",
    component: () =>
      import("@/components/master_data/ProfQualificationGroupsList"),
    meta: { requireAuthorize: true }
  },
  {
    path: "/admin/lists/profQualificationApprovalReasons",
    name: "ProfQualificationApprovalReasons",
    component: () =>
      import("@/components/master_data/ProfQualificationApprovalReasons"),
    meta: { requireAuthorize: true }
  },
  {
    path: "/admin/lists/eventcodes",
    name: "EventcodesList",
    component: () => import("@/components/master_data/EventcodesList"),
    meta: { requireAuthorize: true }
  },
  {
    path: "/admin/lists/competitionRules",
    name: "CompetitionRulesList",
    component: () => import("@/components/master_data/CompetitionRulesList"),
    meta: { requireAuthorize: true }
  },
  {
    path: "/admin/lists/licenceCategories",
    name: "LicenceCategoriesList",
    component: () => import("@/components/master_data/LicenceCategoriesList"),
    meta: { requireAuthorize: true }
  },
  {
    path: "/admin/lists/difficultyLevels",
    name: "DifficultyLevelsList",
    component: () => import("@/components/master_data/DifficultyLevelsList"),
    meta: { requireAuthorize: true }
  },
  {
    path: "/admin/lists/profQualifications",
    name: "ProfQualificationsList",
    component: () => import("@/components/master_data/ProfQualificationsList"),
    meta: { requireAuthorize: true }
  },
  {
    path: "/admin/lists/difficultyGroups",
    name: "DifficultyGroupsList",
    component: () => import("@/components/master_data/DifficultyGroupsList"),
    meta: { requireAuthorize: true }
  },
  {
    path: "/admin/lists/roles",
    name: "RolesList",
    component: () => import("@/components/master_data/RolesList"),
    meta: { requireAuthorize: true }
  },
  {
    path: "/admin/lists/competitionLevels",
    name: "CompetitionLevelsList",
    component: () => import("@/components/master_data/CompetitionLevelsList"),
    meta: { requireAuthorize: true }
  },
  {
    path: "/admin/lists/eventInfoCategories",
    name: "EventInfoCategoriesList",
    component: () => import("@/components/master_data/EventInfoCategoriesList"),
    meta: { requireAuthorize: true }
  },
  {
    path: "/admin/lists/event_product_categories",
    name: "ProductsList",
    component: () =>
      import(
        "@/components/master_data/EventProductCategories/EventProductCategories.vue"
      ),
    meta: { requireAuthorize: true }
  },
  {
    path: "/admin/lists/breeds",
    name: "BreedsList",
    component: () => import("@/components/master_data/BreedsList"),
    meta: { requireAuthorize: true }
  },
  {
    path: "/admin/lists/custom_configurations",
    name: "CustomConfigurationsList",
    component: () =>
      import("@/components/master_data/CustomConfigurationsList"),
    meta: { requireAuthorize: true }
  },
  {
    path: "/admin/lists/competition_sections",
    name: "CompetitionSectionsList",
    component: () => import("@/components/master_data/CompetitionSectionsList"),
    meta: { requireAuthorize: true }
  },
  {
    path: "/admin/lists/mappings",
    name: "Tehnical3rdpartyMappingList",
    component: () => import("@/components/master_data/Tech3rdpartyMappings"),
    meta: { requireAuthorize: true }
  },
  {
    path: "/admin/lists/cups",
    name: "CupsList",
    component: () => import("@/components/master_data/CupsList"),
    meta: {
      requireAuthorize: true
    }
  },
  {
    path: "/admin/lists/cupsseasons",
    name: "CupsSeasonsList",
    component: () => import("@/components/master_data/CupsSeasonsList"),
    meta: { requireAuthorize: true }
  },
  {
    path: "/admin/lists/charts",
    name: "ChartList",
    component: () => import("@/components/master_data/charts/ChartList"),
    meta: { requireAuthorize: true }
  },
  {
    path: "/admin/lists/chartrules",
    name: "ChartRules",
    component: () =>
      import("@/components/master_data/charts/chartRule/ChartRules"),
    meta: { requireAuthorize: true }
  },
  {
    path: "/admin/lists/chartrule/new",
    name: "ChartRuleNew",
    component: () =>
      import("@/components/master_data/charts/chartRule/ChartRuleForm"),
    meta: { requireAuthorize: true }
  },
  {
    path: "/admin/lists/chartrule/:chartRuleId/edit",
    name: "ChartRuleEdit",
    props: true,
    component: () =>
      import("@/components/master_data/charts/chartRule/ChartRuleForm"),
    meta: { requireAuthorize: true }
  },
  {
    path: "/admin/lists/rules",
    name: "Rules",
    component: () => import("@/components/master_data/Rules/Rules"),
    meta: { requireAuthorize: true }
  },
  {
    path: "/admin/lists/qualificationGroups",
    name: "QualificationGroups",
    component: () =>
      import("@/components/master_data/qualifications/QualificationGroups"),
    meta: { requireAuthorize: true }
  },
  {
    path: "/admin/lists/qualifications",
    name: "Qualifications",
    component: () =>
      import("@/components/master_data/qualifications/Qualifications"),
    meta: { requireAuthorize: true }
  },
  {
    path: "/admin/lists/qualificationRules",
    name: "QualificationRules",
    component: () =>
      import(
        "@/components/master_data/qualifications/qualificationRule/QualificationRules"
      ),
    meta: { requireAuthorize: true }
  },
  {
    path: "/admin/lists/qualificationRules/:qualificationRuleId/edit",
    name: "QualificationRuleEdit",
    props: true,
    component: () =>
      import(
        "@/components/master_data/qualifications/qualificationRule/QualificationRuleEdit"
      ),
    meta: { requireAuthorize: true }
  },
  {
    path: "/admin/lists/qualificationRules/new",
    name: "QualificationRuleNew",
    component: () =>
      import(
        "@/components/master_data/qualifications/qualificationRule/QualificationRuleEdit"
      ),
    meta: { requireAuthorize: true }
  },
  {
    path: "/admin/surveys",
    name: "SurveysMasterdata",
    props: true,
    component: () => import("@/components/master_data/Surveys"),
    meta: { requireAuthorize: true }
  },
  {
    path: "/admin/surveyelements",
    name: "SurveyElementsMasterdata",
    props: true,
    component: () => import("@/components/master_data/SurveyElements"),
    meta: { requireAuthorize: true }
  },
  {
    path: "/admin/sanction_reasons",
    name: "SanctionReasons",
    props: true,
    component: () => import("@/components/master_data/SanctionReasons"),
    meta: { requireAuthorize: true }
  },
  {
    path: "/admin/sanction_definitions",
    name: "SanctionDefinitions",
    props: true,
    component: () => import("@/components/master_data/SanctionDefinitions"),
    meta: { requireAuthorize: true }
  },

  {
    path: "/admin/event_staff_function_definitions",
    name: "EventStaffFunctionDefinitions",
    props: true,
    component: () =>
      import(
        "@/components/master_data/EventStaffFunctions/EventStaffFunctionDefinitions.vue"
      ),
    meta: { requireAuthorize: true }
  },
  {
    path: "/admin/event_staff_function_team_templates",
    name: "EventStaffFunctionTeamTemplates",
    props: true,
    component: () =>
      import(
        "@/components/master_data/EventStaffFunctions/EventStaffFunctionTeamTemplates.vue"
      ),
    meta: { requireAuthorize: true }
  }
];
